import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Card, CardContent } from '../ui/card';
// import { AutomationScope } from '../AutomationDashboard';
import { AutomationContentType, AutomationScope } from 'custom-type'
import * as gtUtil from "../../../../../../core/utility";
// import { AutomationContentType } from '../SetupWizard';
import { FileText, Files, Layers, Check, Image, Images, Lock, LucideIcon } from 'lucide-react';

import instaLive from '../../../../../../assets/images/zap-live.svg';
import instaLive1 from '../../../../../../assets/images/zap-live.svg';
import instaStory from '../../../../../../assets/images/zap-story.svg';
import instaReel from '../../../../../../assets/images/zap-post-reel.svg';

// interface StepScopeProps {
//   name: string;
//   setName: (name: string) => void;
//   scope: AutomationScope | null;
//   setScope: (scope: AutomationScope) => void;
// }

// type CardType = {
//   title: string;
//   Icon: LucideIcon;
// };

// interface StepScopeProps {
//   name: string;
//   setName: (name: string) => void;

//   contentType: AutomationContentType;
//   setContentType: (type: AutomationContentType) => void;

//   scope: AutomationScope;
//   setScope: (scope: AutomationScope) => void;

//   isEditting: boolean;

//   disableLive: boolean;
// }

interface StepScopeProps {
  disableLive: boolean;
  entitlements: any;
  contentType: AutomationContentType;
  setContentType: (type: AutomationContentType) => void;
  setScope: (type: AutomationScope) => void;
  // showZaps: boolean;
  // setShowZaps: (type: boolean) => void;
  // handleCreateAutomation: () => void;
  handleOpenConnectInstagramModal: (type: AutomationContentType) => void;
}

/**
 * Small "Upgrade" pill, matching the one on the Zap hub cards (ZapHub.tsx):
 * lock glyph, violet on a pale violet ground.
 */
const UpgradePill = () => (
  <span className="inline-flex items-center gap-1 rounded-full bg-[#f3f0ff] px-2 py-[2px] text-[11px] font-semibold leading-none text-[#7c3aed]">
    <Lock className="h-[11px] w-[11px]" />
    Upgrade
  </span>
);

export function StepScope( props: StepScopeProps ) {
  // A content type is locked when the plan's allowed_content_types excludes it.
  // FOC carries 'post' only, so Story and Live are locked there; every paid and
  // trial plan carries 'post,story,live'.
  const isContentTypeLocked = (type: AutomationContentType) =>
    !gtUtil.isContentTypeAllowed(props.entitlements, type || '');
  // const options = [
  //   {
  //     value: 'single' as AutomationScope,
  //     icon: contentType === 'story' ? Image : FileText,
  //     title: contentType === 'story' ? 'Single Story' : 'Single Post',
  //     description: contentType === 'story' ? 'Automate responses for one specific story' : 'Automate responses for one specific post',
  //   },
  //   {
  //     value: 'multiple' as AutomationScope,
  //     icon: contentType === 'story' ? Images : FileText,
  //     title: contentType === 'story' ? 'Multiple Stories' : 'Multiple Posts',
  //     description: contentType === 'story' ? 'Select specific stories to automate' : 'Select specific posts to automate',
  //   },
  //   // {
  //   //   value: 'all' as AutomationScope,
  //   //   icon: Layers,
  //   //   title: 'All Posts',
  //   //   description: 'Apply automation to all active posts',
  //   // },
  // ];

  const options = [
    {
      value: "multiple" as AutomationScope,
      icon: Images,
      title: 'Zaps',
      description: 'Existing automations',
    }
  ];

  const InstaLiveIcon = ({ size = 70, isSelected = false, }: { size?: number,isSelected?: boolean,}) => (
    <div className='d-flex justify-content-center align-items-center mb-2'>
      <img
        src={isSelected ? instaLive1 : instaLive}
        alt="Insta Live"
        width={size}
        height={size}
        style={{ objectFit: 'contain' }}
        
      />
    </div>
  );

  const InstaStoryIcon = ({ size = 70, isSelected = false, }: { size?: number,isSelected?: boolean,}) => (
    <div className='d-flex justify-content-center align-items-center mb-2'>
      <img
        src={instaStory}
        alt="Insta Live"
        width={size}
        height={size}
        style={{ objectFit: 'contain' }}
        
      />
    </div>
  );
  const InstaReelIcon = ({ size = 70, isSelected = false, }: { size?: number,isSelected?: boolean,}) => (
    <div className='d-flex justify-content-center align-items-center mb-2'>
      <img
        src={instaReel}
        alt="Insta Live"
        width={size}
        height={size}
        style={{ objectFit: 'contain' }}
        
      />
    </div>
  );

  type IconType = LucideIcon | React.FC<{ size?: number }>;

  const contentTypes: {
    value: AutomationContentType;
    icon: IconType;
    image?: string;
    title: string;
    subTitle: string;  
  }[] = [
    { value: 'post', icon: InstaReelIcon, title: 'ZAP Post/Reel', subTitle: "Auto - respond to comments with DMs on your Post/Reel " },
    { value: 'story', icon: InstaStoryIcon, title: 'ZAP Story', subTitle: "Auto - respond to comments with DMs on your Stories" },
    { value: 'live', icon: InstaLiveIcon, title: 'ZAP Live', subTitle: "Auto - respond to comments with DMs when you are Live"},
  ];

  return (
    <div className="space-y-6">
      {/* <div className="space-y-2">
        <Label htmlFor="name">Automation Name</Label>
        <Input
          id="name"
          placeholder="e.g., Product Launch Campaign"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <p className="text-xs text-gray-500">
          Give your automation a descriptive name
        </p>
      </div> */}
      {/* Content Type */}
      <div className="space-y-3">
        {/* <Label>Select Content Type</Label> */}
        {/* <Label>Create new Zap</Label> */}

        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
          {contentTypes.map((type) => {
            const Icon = type.icon;
            const isSelected = props.contentType === type.value;
            const locked = isContentTypeLocked(type.value);
            // `disableLive` is the legacy beta kill switch (now always false). A locked
            // card is NOT disabled: it stays clickable and routes to the upgrade popup,
            // which handleOpenConnectInstagramModal already does via allowed_content_types.
            const isDisabled = (type.value === "live" && props.disableLive);

            return (
              <Card
                key={type.value}
                className={
                  `transition-all 
                  ${
                    isSelected ? 'border-purple-500 bg-[#000]' : 'border-gray-200'
                  } 
                  ${
                    isDisabled ? 'pointer-events-none opacity-60' : 'cursor-pointer'
                  }
                  ${
                    (!isDisabled && locked) ? 'opacity-75' : ''
                  }`
                }
                onClick={() => {
                  if (isDisabled) return;
                  // setContentType(type.value);
                  // if (type.value === 'live') {
                  //   setScope(null); // live doesn’t need scope
                  // }
                  props.handleOpenConnectInstagramModal(type.value);
                }}
                aria-disabled={isDisabled}
              >
                <CardContent className="p-3 md:p-6 d-flex gap-3">
                  {type.value === 'live' ? (
                    <InstaLiveIcon isSelected={isSelected} />
                  ) : (
                    <type.icon
                      className={`mx-auto mb-2 ${
                        isSelected ? 'text-white' : 'text-gray-600'
                      }`}
                    />
                  )}
                  {/* <Icon className={`mx-auto mb-2 ${isSelected ? 'text-white' : 'text-gray-600'}`} /> */}
                  <div className='d-flex flex-column items-start'>
                    <div className="d-flex items-center gap-2 flex-wrap">
                      <p className={isSelected ? 'text-white font-semibold' : 'font-semibold'}>{type.title}</p>
                      {/* Locked by the plan (allowed_content_types) -> same Upgrade pill the
                          Zap hub cards use, so Story / Live read as upsells instead of as
                          cards that pop an error only after being clicked. */}
                      {locked && <UpgradePill />}
                    </div>
                    <p className={`text-[14px] ${isSelected ? 'text-white' : ''}`}>{type.subTitle}</p>
                  </div>
                  {/* OLD (beta-era "Coming Soon" on ZAP Live). The beta gate is gone, so
                      availability is now purely a plan question and shows as the pill above:
                  {(type.value === 'live' && props.disableLive) &&
                  <small className={`text-coming-soon text-[12px] ${props.disableLive ? 'text-orange-400' : ''}`}>Coming Soon</small>
                  } */}
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>

      {/* <div className="space-y-3">
        <Label>Zaps Dashboard</Label>

        <div className="grid grid-cols-1 md:grid-cols-1 gap-4">
          {options.map((option) => {
            const Icon = option.icon;
            // const isSelected = props.contentType === type.value;
            // const isDisabled = (option.value === "live" && props.disableLive);
            const isSelected = props.showZaps;
            const isDisabled = false;
            // const isDisabled = isEditting;

            return (
              <Card
                key={option.value}
                className={
                  `transition-all 
                  ${
                    isSelected ? 'border-purple-500 bg-[#000]' : 'border-gray-200'
                  } 
                  ${
                    isDisabled ? 'pointer-events-none opacity-60' : 'cursor-pointer'
                  }`
                }
                onClick={() => {
                  props.setContentType(null);
                  props.setScope(null);
                  props.setShowZaps(true);
                }}
                aria-disabled={isDisabled}
              >
                <CardContent className="p-6 text-center">
                  <Icon className={`mx-auto mb-2 ${
                    isSelected ? 'text-[#2b2b2b]' : 'text-gray-600'
                  }`} />
                  <p className={isSelected ? 'text-white' : ''}>{option.title}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div> */}

      {/* Scope */}
      {/* {['story', 'post'].includes(contentType || '') && (
        <div className="space-y-3">
          <Label>Select Automation Scope</Label>
          <p className="text-sm text-gray-500">
            Choose which {contentType === 'story' ? 'stories' : 'posts'} this automation will apply to
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {options.map((option) => {
              const Icon = option.icon;
              const isSelected = scope === option.value;

              return (
                <Card
                  key={option.value}
                  className={
                    `transition-all hover:border-purple-300 
                    ${
                      isSelected
                      ? 'border-purple-500 bg-[#000] shadow-md'
                      : 'border-gray-200'
                    } 
                    ${ 
                      isEditting ? 'pointer-events-none opacity-60' : 'cursor-pointer' 
                    }`
                  }
                  onClick={() => {
                    if (isEditting) return;
                    setScope(option.value)
                  }}
                  aria-disabled={isEditting}
                >
                  <CardContent className="p-6">
                    <div className="flex items-start justify-between mb-3">
                      <div className={`p-3 rounded-lg ${
                        isSelected ? 'bg-white' : 'bg-gray-100'
                      }`}>
                        <Icon className={`w-6 h-6 ${
                          isSelected ? 'text-[#2b2b2b]' : 'text-gray-600'
                        }`} />
                      </div>
                      {isSelected && (
                        <div className="bg-white rounded-full p-1">
                          <Check className="w-4 h-4 text-[2b2b2b]" />
                        </div>
                      )}
                    </div>
                    <h3 className={`mb-2 ${
                      isSelected ? 'text-white' : ''
                    }`}>
                      {option.title}
                    </h3>
                    <p className={`text-sm text-gray-600  ${isSelected ? 'text-[#bbb]' : ''}`}>
                      {option.description}
                    </p>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      )} */}
    </div>
  );
}